import {
  Box,
  Columns,
  Container,
  Heading,
  Stack,
  Text,
  Visible,
} from '@spaceship-fspl/components';
import { TrackingCategory } from '@spaceship-fspl/tracking';
import { PanelSection } from 'components';
import introductionDesktopImage from 'images/first-home_introduction-desktop.svg';
import introductionMobileImage from 'images/first-home_introduction-mobile.svg';
import React from 'react';

export interface IntroductionPanelProps {
  title?: string | null;
  tagline?: React.ReactNode;
}

export const IntroductionPanel: React.FC<IntroductionPanelProps> = ({
  title,
  tagline,
}) => {
  return (
    <TrackingCategory category="Introduction Panel">
      <PanelSection>
        <Container>
          <Columns
            reverse={{ lg: true }}
            alignX="center"
            alignY={{ lg: 'center' }}
            spaceX={{ lg: 'xxl' }}
            spaceY={{ xs: 'lg', lg: 'none' }}
          >
            <Columns.Column width={{ lg: 1 / 2 }}>
              <Visible isHidden={{ lg: true }}>
                <img src={introductionMobileImage} alt={title ?? ''} />
              </Visible>

              <Visible isHidden={{ xs: true, lg: false }}>
                <Box marginY={{ lg: 'xl' }}>
                  <img src={introductionDesktopImage} alt={title ?? ''} />
                </Box>
              </Visible>
            </Columns.Column>

            <Columns.Column width={{ lg: 1 / 2 }}>
              <Stack spaceY={{ xs: 'sm', lg: 'md' }}>
                <Heading
                  component="h2"
                  variant={2}
                  color="neutral.100"
                  align={{ xs: 'center', lg: 'left' }}
                >
                  {title}
                </Heading>

                <Text
                  variant={1}
                  color="neutral.080"
                  align={{ xs: 'center', lg: 'left' }}
                  component="div"
                >
                  {tagline}
                </Text>
              </Stack>
            </Columns.Column>
          </Columns>
        </Container>
      </PanelSection>
    </TrackingCategory>
  );
};
